module.exports = __webpack_public_path__ + "static/media/restoration-page.e4e30bdc.jpg";